module.exports = __webpack_public_path__ + "static/media/logo.fa1a2cea.png";